import * as z from "zod/v4";

export const getManifestableGroupsCounts = {
  name: "getManifestableGroupsCounts" as const,
  input: z.object({}),
  output: z.object({
    countsByCarrier: z.object({
      usps: z.number(),
      dhlEcs: z.number(),
      globale: z.number().nullish(),
      speeDee: z.number().nullish(),
      australiaPost: z.number().nullish(),
    }),
  }),
};
